/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

function FollowCard({ content = {} }) {
  const toggleClass = (e) => {
    document.querySelector('#card-follow-arrow').classList.add('hoveredPointer');
  };

  const removeClass = (e) => {
    document.querySelector('#card-follow-arrow').classList.remove('hoveredPointer');
  };

  const redirectCard = () => {
    // content?.url;
    window.open(content?.url, '_self');
  };

  return (
    <div className="w-full" key={content?.title}>
      <button
        key={content.tags[0]}
        className="blog-card"
        onClick={redirectCard}
        onMouseOver={(e) => toggleClass(e)}
        onMouseOut={(e) => removeClass(e)}
      >
        <img src={content?.thumbnail_images?.large?.url || content?.thumbnail || 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YXJ0aWNsZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60'} alt="cover" />
        {/* <img src={content.img} alt="cover" /> */}

        {/* ---tag / type ---- */}
        <div className=" absolute bottom-3 left-3 font-bold flex items-center gap-2">
          {
            content?.tags && content?.tags.map((el) => <span className="bg-white px-4 py-2 rounded-full font-normal text-sm min-w-[3rem] max-w-[8rem] truncate">{el?.title}</span>)
          }
        </div>

      </button>
      {/* ---title--- */}
      <div className="w-full px-3 font-[500]">{content?.title}</div>
    </div>
  );
}

export default FollowCard;
